import { render, staticRenderFns } from "./BotaoBaixarDocumentoEmLote.vue?vue&type=template&id=3344f2e8&scoped=true"
import script from "./BotaoBaixarDocumentoEmLote.vue?vue&type=script&lang=js"
export * from "./BotaoBaixarDocumentoEmLote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3344f2e8",
  null
  
)

export default component.exports